import { ChangeEvent, useState } from 'react';
import { Divider } from 'primereact/divider';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { ReactComponent as GoogleIcon } from '../../../icons/GoogleColorIcon.svg';
import { ReactComponent as LinkedInIcon } from '../../../icons/LinkedInWhiteIcon.svg';
import useLoginEmployerForm from './hooks/useLoginEmployerForm';

const EmployerLoginForm = () => {
  const {
    submitForm,
    handleSubmit,
    isValid,
    errors,
    email,
    password,
    onGoogleSignIn,
    onLinkedInSignIn,
    t,
  } = useLoginEmployerForm();
  const [isPasswordVisible, setPasswordVisibility] = useState(false);

  return (
    <form
      data-testid="login-form"
      className="flex flex-col gap-10"
      onSubmit={handleSubmit(submitForm)}
    >
      <div className="flex flex-col gap-4">
        <div className="w-full flex flex-col gap-1">
          <label htmlFor="email" className="text-spk-mediumContrast text-xs">
            {t('register.emailInput')}
          </label>
          <IconField iconPosition="left" className="w-full">
            <InputIcon className="pi pi-envelope"> </InputIcon>
            <InputText
              onChange={(e: ChangeEvent) => email.onChange(e)}
              name={email.name}
              onBlur={email.onBlur}
              ref={email.ref}
              type="text"
              className={`w-full ${errors.email && 'border-spk-brightRed'}`}
            />
          </IconField>
          {errors.email && (
            <small data-testid="input-error" className="text-spk-brightRed">
              {t('login.emailFormat')}
            </small>
          )}
        </div>
        <div className="w-full flex flex-col gap-1">
          <label htmlFor="password" className="text-spk-mediumContrast text-xs">
            {t('register.passwordInput')}
          </label>
          <IconField iconPosition="left" className="w-full p-icon-field-right">
            <InputIcon className="pi pi-key"> </InputIcon>
            <InputText
              onChange={(e: ChangeEvent) => password.onChange(e)}
              name={password.name}
              onBlur={password.onBlur}
              ref={password.ref}
              type={isPasswordVisible ? 'text' : 'password'}
              className={`w-full ${errors.password && 'border-spk-brightRed'}`}
            />
            <InputIcon
              onClick={() => setPasswordVisibility(!isPasswordVisible)}
              className={`cursor-pointer pi ${
                isPasswordVisible ? 'pi-eye-slash' : 'pi-eye'
              }`}
            />
          </IconField>
          {errors.password && (
            <small data-testid="input-error" className="text-spk-brightRed">
              Required
            </small>
          )}
          <div className="flex justify-end ">
            <a
              href="recover_password"
              className="font-bold text-spk-brightBlue underline"
            >
              {t('login.forgotPass')}
            </a>
          </div>
        </div>
      </div>
      <div>
        <div className="w-full">
          <Button
            severity="success"
            label={t('login.login')}
            className="w-full"
            disabled={!isValid}
          />
        </div>
        <Divider align="center" className="py-8 m-0 ">
          <p className="text-xs font-normal">{t('common.or')}</p>
        </Divider>
        <div
          data-testid="login-buttons"
          className="w-full flex gap-4 justify-center"
        >
          <Button
            severity="secondary"
            className="w-fill-available flex gap-4"
            outlined
            style={{ border: '1px solid' }}
            onClick={onGoogleSignIn}
          >
            <GoogleIcon />
            <p>Google</p>
          </Button>
          <Button
            severity="secondary"
            className="w-fill-available flex gap-4"
            outlined
            style={{ border: '1px solid' }}
            onClick={onLinkedInSignIn}
          >
            <LinkedInIcon />
            <p>LinkedIn</p>
          </Button>
        </div>
      </div>
    </form>
  );
};

export default EmployerLoginForm;
